import TubCommon from "./tubCommon";

export default class BathTubLiner extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = "bathtub_liner";
    this.bottomTubId = "bathtub_liner";
    this.visible = true;
    this.partName = "Tub Liner";
    this.translateId = "visualizer.bathroom.shower_tub_combo.bathtub_liner";
    this.dbName = "Bathtub Liner";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
  }
}
